import OtherSellers from '../other-sellers';

const FEATURE_NAME = 'bbw_alternatives';

export default OtherSellers(FEATURE_NAME);
